var dateFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
export var parseDate = function (value) {
    if (typeof value === "string" && dateFormat.test(value)) {
        return new Date(value).getTime();
    }
    else if (value != null && typeof value === "object" && 'seconds' in value) {
        return value.seconds * 1000;
    }
    else if (value != null && typeof value === "object" && '_seconds' in value) {
        return value._seconds * 1000;
    }
    return value;
};
// Add field on account level for speed threshold.
// Hardcoding, since we're uncertain about doing it on group level or account level
// 2 Speed Threshold for Neom account: SEuU5bcSn5ZO1mBpoWCr
var SpeedThreshold = 5;
export var getSpeedThreshold = function (accountId) {
    return accountId === 'SEuU5bcSn5ZO1mBpoWCr' ? 2 : SpeedThreshold;
};
